import { loanApplicationBorrowersApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { LOAN_APPLICATION_ACTION_NAME_PREFIX } from 'constants/loanApplication';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const BORROWERS_ACTION_TYPE = createNamedActions(
  // LOAN_APPLICATION_ACTION_NAME_PREFIX is used for Redux Middleware in Loan Editor
  `${LOAN_APPLICATION_ACTION_NAME_PREFIX}/borrowers`,
  {
    GET_BORROWERS: 'GET_BORROWERS',
  },
);

const borrowersSchema = new schema.Entity('data', {}, { idAttribute: 'id' });

export const getApplicationBorrowersAction = catchAsyncActionError(
  ({ applicationId }) =>
    async dispatch => {
      const { data } = await loanApplicationBorrowersApi.getBorrowersInfo({
        applicationId,
      });

      return dispatch({
        type: BORROWERS_ACTION_TYPE.GET_BORROWERS,
        payload: normalize(
          data?.map(borrower => ({
            ...borrower,
            borrowerId: borrower.id,
            orderNumber: borrower.order,
            cellPhoneNumber: borrower.cellPhone,
          })),
          [borrowersSchema],
        ).entities.data,
      });
    },
);
